export const CLOSED_TYPIFICATION_STATUSES = {
    NON_EXISTENT_CONTACT_TYPIFICATION: 1,
    CLOSED_TYPIFICATION: 3,
    ALREADY_PUBLISH_TYPIFICATION: 4,
    SUCCESS_TYPIFICATION: 5,
    NOT_PROFILED_TYPIFICATION: 6,
    OTHER_TYPIFICATION: 7,
};

export const NOT_CLOSED_TYPIFICATION_STATUSES = {
    WITHOUT_TYPIFICATION: 0,
    IN_PROGRESS_TYPIFICATION: 2,
};

export const STATUS_PROSPECTS = {
    OPEN: 0,
    CLOSED: 1,
};
